import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** chevron pointing left. Decorative line icon; always pair with a visible text label. */
export function ChevronLeftIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M14.5 5.5L8 12l6.5 6.5" />
    </IconSvg>
  )
}
